import {ActionType, createAction} from "typesafe-actions"
import Terms from "../models/terms"

export const getDatabaseAction = createAction("GET_DATABASE")<void>()
export const getDatabaseSuccessAction = createAction(
    "GET_DATABASE_SUCCESS"
)<string>()
export const getUserSuccessAction = createAction("GET_USER_SUCCESS")<boolean>()
export const getRolesSuccessAction = createAction("GET_ROLES_SUCCESS")<[]>()

export const getShowDisclaimerSuccessAction = createAction(
    "SET_SHOW_DISCLAIMER_SUCCESS"
)<boolean>()
export const getShowDisclaimerAction = createAction(
    "GET_SHOW_DISCLAIMER"
)<void>()
export const saveTermsAction = createAction("SAVE_TERMS")<Terms>()
export const saveTermsSuccessAction = createAction(
    "SAVE_TERMS_SUCCESS_ACTION"
)<any>()

/**
 * Export Action types for Core. Used in core reducers and epics
 */
export type CoreActions = ActionType<
    | typeof getDatabaseAction
    | typeof getDatabaseSuccessAction
    | typeof getUserSuccessAction
    | typeof getShowDisclaimerSuccessAction
    | typeof saveTermsAction
    | typeof saveTermsSuccessAction
    | typeof getShowDisclaimerAction
    | typeof getRolesSuccessAction
>
